require('./mortgageRequestDuesPaymentsView.scss');

// @vendors
const React = require('react');
const { connect } = require('react-redux');
const { formatText } = require('core/i18n').i18n;
const { withRouter } = require('react-router-dom');
const PropTypes = require('prop-types');

// @utilities
const dateHelper = require('utilities/dateHelper');

// @loans
const { okLoansComponents } = require('ok-loans');

// @components
const { CommercialAds } = require('components/commons/commercialAds/commercialAds');
const LoanHeader = okLoansComponents.loanHeader;
const MortgageRequestDuesPayments = require('components/mortgageRequest/mortgageRequestDuesPayments/mortgageRequestDuesPayments');

// @constants
const { getUnpaidFees } = require('constants/loans');


class MortgageRequestDuesPaymentsView extends React.Component {
    componentWillMount() {
        if (this.props.unpaidFeesState.get('unpaidFeesList').isEmpty()) {
            this.props.history.push(`/myprofile/loans-mortgages/loans/${this.props.match.params.loanId}/unpaid-fees`);
        } else {
            this.setInfo();
        }
    }

    setInfo() {
        const {
            immLoansState,
            match: { params: { loanId, feeIndex } },
            unpaidFeesState,
            immProfile
        } = this.props
        let isAresFlag = immProfile.get('isAresUser');
        this.loan = immLoansState.getIn(['byId', loanId], false);

        this.fee = unpaidFeesState.getIn(['unpaidFeesList', feeIndex]).toJS();

        const getFeeDate = dateHelper.formatDate(this.fee.date);
        const feeDate = getFeeDate !== 'Invalid Date' && getFeeDate;
        const loanPrefix = this.loan.get('isPersonal') ? '' : `-${this.loan.get('type')}`;

        this.headerTitle = formatText('mortgageRequestDuesPayments-title', [this.fee.number, feeDate]);

        this.mappingBreadcrumb = [
            {
                text: formatText('navbar-loans'),
                url: isAresFlag ? '/myprofile/loans-mortgages/aresusers' : '/myprofile/loans-mortgages'
            },
            {
                text: this.loan.get('alias'),
                url: isAresFlag ? `/myprofile/loans-mortgages/ares${loanPrefix}-loans/${loanId}` : `/myprofile/loans-mortgages/loans/${loanId}`
            },
            {
                text: formatText('mortgageRequestUnpaidFees-breadcrumbTitle'),
                url: isAresFlag ? `/myprofile/loans-mortgages/ares-loans/${loanId}/unpaid-fees` : `/myprofile/loans-mortgages/loans/${loanId}/unpaid-fees`
            },
            {
                text: formatText('mortgageRequestDuesPayments-breadcrumbTitle2'),
                url: ''
            }
        ];

        this.anotherDetails = (
            <div className="mortgage-request-dues-payment-view__another-details">
                <div className="mortgage-request-dues-payment-view__another-details-title">
                    {formatText('mortgageRequestDuesPayments-state')}
                </div>
                <div className="mortgage-request-dues-payment-view__another-details-state">
                    {getUnpaidFees().STATE_TYPES[this.fee.stateKey]}
                </div>
            </div>
        );
    }

    render() {
        const { immProfile } = this.props;
        let isAresValue = immProfile.get('isAresUser');
        if (!this.fee) {
            return null;
        }

        return (
            <div className="mortgage-request-dues-payment-view">
                <LoanHeader
                    immLoan={this.loan}
                    breadcrumbConfig={this.mappingBreadcrumb}
                    title={this.headerTitle}
                    showDetails={false}
                    showAnotherDetails={this.anotherDetails}
                    isMortgage
                    isARES={isAresValue}
                />
                <section className="mortgage-request-dues-payment-view__body">
                    <div className="row">
                        <div className="col-xs-9">
                            <MortgageRequestDuesPayments
                                paymentsList={this.fee.feeDetails}
                            />
                        </div>
                        <div className="col-xs-3">
                            {!isAresValue ? <CommercialAds path="loans-mortgages/loans/:loanId/unpaid-fees/detail/:feeIndex" type="cross-selling" /> : ''}
                        </div>
                    </div>
                </section>
            </div>
        );
    }
}

MortgageRequestDuesPaymentsView.propTypes = {
    history: PropTypes.object.isRequired,
    match: PropTypes.object.isRequired,
    duesPaymentsState: PropTypes.object,
    immLoansState: PropTypes.object,
    unpaidFeesState: PropTypes.object,
    isFetching: PropTypes.bool,
    immProfile: PropTypes.object
};

module.exports.constructor = MortgageRequestDuesPaymentsView;
module.exports.MortgageRequestDuesPaymentsView = connect(state => ({
    duesPaymentsState: state.mortgageRequestDuesPayments,
    immLoansState: state.loans,
    unpaidFeesState: state.mortgageRequestUnpaidFees,
    immProfile: state.profile,
}), null)(withRouter(MortgageRequestDuesPaymentsView));
